import {call, put, race, take} from 'redux-saga/effects';
import {action} from 'redux-create-type';
import sum from 'lodash/sum';


export function* takeFetch(actionType) {
  const { SUCCESS, FAILURE } = actionType;
  return yield race({ success: take(SUCCESS), failure: take(FAILURE) });
}

export function api(actionType, actionCreator, util) {
  return function* apiTask() {
    while (true) {
      const { params } = yield take(actionType.REQUEST);
      try {
        const data = yield call(util, params);
        yield put(actionCreator.success(data));
      } catch (err) {
        yield put(actionCreator.failure(err));
      }
    }
  };
}

export function fetchCreator(type) {
  return {
    request: params => action(type.REQUEST, { params }),
    success: data => action(type.SUCCESS, { data }),
    failure: error => action(type.FAILURE, { error }),
  };
}

export function applyReducers(reducers, previosState, actionValue) {
  return Object.keys(reducers).reduce((state, key) => {
    const value = reducers[key](state[key], actionValue);
    if (value !== state[key]) {
      return {
        ...state,
        [key]: value,
      };
    }
    return state;
  }, previosState);
}

export function reloadBacklog() {
    const board = angular.element('#sprintPlanningContainer');
    if(board.length) {
        board.injector().get('$rootScope').$emit('sprintSaved');
        return true;
    }
    return false;
}

export function getInjector() {
  return angular.element('[ng-app]').injector();
}

export const getTotalChanges = options => sum(options.map(x => x.changes));

export const createSetCostOfEstimation = (actions, after) => {
  return function*() {
    while (true) {
      const {costOfEstimationModel} = yield take(actions.SET_COST_OF_ESTIMATION.BEGIN);
      const durationConverter = getInjector().get('durationService').getConverter();
      yield put(actions.setCostOfEstimation.end({costOfEstimationUnit: durationConverter.toMinutes(costOfEstimationModel)}));
      if(after) {
        yield call(after);
      }
    }
  }
};

export const createSetCostOfEstimationActions = SET_COST_OF_ESTIMATION => ({
  begin: costOfEstimationModel => action(SET_COST_OF_ESTIMATION.BEGIN, { costOfEstimationModel }),
  end: ({ costOfEstimationUnit }) => action(SET_COST_OF_ESTIMATION.END, { costOfEstimationUnit }),
});

export const replaceNaNInfinityWithDash = num => isNaN(num) || !isFinite(num) ? '—': num;


// WEBPACK FOOTER //
// ../redux/helpers.js